export const fudrAnalyticsGTMVariables = {
  eventCategory: 'ga_category',
  eventAction: 'ga_action',
  eventLabel: 'ga_label',
  restaurantCode: 'ga_restaurants',
  origin: 'ga_sources',
  customResult: 'ga_custom_results',
};

export const fudrAnalyticsGTMEvents = {
  pageView: 'pageview',
  permission: 'permission',
};

export const fudrAnalyticsGTMEventCategory = {
  pageView: {
    page: 'page',
  },
  permission: {
    user: 'user',
  },
};

export const fudrAnalyticsGTMEventLabel = {
  pageView: {
    welcome: 'welcome',
  },
  permission: {
    camera: 'camera',
    location: 'geolocation',
  },
};
